import { useMemo } from 'react';

import type { FormValues } from '#src/app/pages/petitionDetails/shared/types';
import type { StateWithoutError } from '#src/app/shared/utils/async';
import { isLoading } from '#src/app/shared/utils/async';

import { useSignFormGuestInitialValues } from '../useSignFormGuestInitialValues';
import { useSignFormNonGuestInitialValues } from '../useSignFormNonGuestInitialValues';

export type SignFormInitialValues = Partial<FormValues> | undefined;
type InitialValuesState = StateWithoutError<{ values: SignFormInitialValues }>;

export function useSignFormInitialValues(): InitialValuesState {
	const guestInitialValues = useSignFormGuestInitialValues();
	const nonGuestInitialValues = useSignFormNonGuestInitialValues();

	// so the loading object is always the same for given params
	const loadingState = useMemo(() => ({ status: 'loading' as const }), []);

	return useMemo(() => {
		if (isLoading(nonGuestInitialValues)) {
			return loadingState;
		}

		if (nonGuestInitialValues.values) {
			return nonGuestInitialValues;
		}

		if (isLoading(guestInitialValues)) {
			return loadingState;
		}

		return guestInitialValues;
	}, [guestInitialValues, nonGuestInitialValues, loadingState]);
}
